// Leistungs-Cards: Auf-/Zuklappen macht Bootstrap-Collapse selbst (data-bs-*),
// hier kommt nur das Scrollverhalten dazu.
//
// Warum: die Karten sind sehr hoch (Titel bis 80px + ~86px Innenabstand). Öffnet
// man eine weiter unten liegende Karte, schließt gleichzeitig die vorherige --
// dadurch springt das Layout und der frisch geöffnete Inhalt landet leicht unter
// der Viewport-Kante. Nach der Collapse-Animation (shown.bs.collapse, Layout ist
// dann final) ziehen wir den Kartenkopf sanft unter die sticky Navigation.
//
// Reine Event-Anbindung, kein Inline-JS (§8); prefers-reduced-motion springt
// ohne Animation (§16).
//   <div class="leistungs-cards__stack" data-leistungs-cards> … </div>
export function initLeistungsCards() {
  const stacks = document.querySelectorAll("[data-leistungs-cards]");
  if (stacks.length === 0) return;

  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // Höhe der schwebenden Navbar (72px) + ihr Abstand im gescrollten Zustand
  // (12px oben, 16px unten). Bewusst NICHT .site-header messen: dessen Höhe
  // schrumpft beim Scrollen (.is-scrolled), das Ziel würde mitspringen.
  const headerOffset = () => {
    const bar = document.querySelector(".iba-navbar");
    return (bar ? bar.getBoundingClientRect().height : 72) + 28;
  };

  stacks.forEach((stack) => {
    stack.addEventListener("shown.bs.collapse", (event) => {
      const card = event.target.closest(".leistungs-cards__card");
      if (!card) return;

      const top = Math.max(0, window.scrollY + card.getBoundingClientRect().top - headerOffset());
      // Mini-Korrekturen (Karte sitzt praktisch schon richtig) überspringen,
      // sonst wirkt jeder Klick wie ein Ruckler.
      if (Math.abs(top - window.scrollY) < 8) return;

      window.scrollTo({ top, behavior: reduce ? "auto" : "smooth" });
    });
  });
}
